import { useLocation, useNavigate } from 'react-router-dom'

import { AntTab, AntTabs } from 'common/components/AntTabs'
import { IDataViewProps } from 'features/DataManagement/DataView'

const ViewsAndMyViewsTabs = ({ dvBasePath }: IDataViewProps) => {
  const navigate = useNavigate()
  const { search } = useLocation()

  const handleTabSelect = () => {
    navigate(`${dvBasePath}/list/views${search}`)
  }

  return (
    <AntTabs value={0} onChange={handleTabSelect} style={{ minHeight: '40px' }}>
      <AntTab label='VIEWS' sx={{ minHeight: '40px', height: '40px' }} />
    </AntTabs>
  )
}

export default ViewsAndMyViewsTabs
